import styled from "styled-components";
import type { FontSizeProps, DisplayProps, SpaceProps } from "styled-system";
import { color, space } from "styled-system";
import type { ThemeTypedColorProps } from "../../../../../themes/common";
import { theme } from "../../theme/toyotaTheme";

export const PricesWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Text = styled.div<
    { lineThrough?: boolean; isLarge?: boolean; isSmall?: boolean } & ThemeTypedColorProps &
        FontSizeProps &
        DisplayProps &
        SpaceProps
>`
    display: inline-block;
    font-family: ${theme.fonts.regular};
    font-size: ${({ isSmall, isLarge }) => (isSmall ? "1.3rem" : isLarge ? "2rem" : "1.6rem")};
    line-height: ${({ isSmall }) => (isSmall ? "2rem" : "2.4rem")};
    color: ${theme.colors.primaryBlack};
    ${space};
    ${color};
`;
